// extracted by mini-css-extract-plugin
export default {"coachesContainer":"styleModule_coachesContainer__TlPEu","titleContainer":"styleModule_titleContainer__GUm-u"};